import { useStore } from '../app/context.js';
import { copy } from '../copy.js';
import { MONTH_NAMES } from '../dates.js';
import { cls } from '../parts/classes.js';
import { Spinner } from '../parts/Spinner.js';
import { color, font } from '../tokens.js';

/**
 * App start, before the session is known. Not designed. Implementation default (not from the
 * prototype): the calendar's own loading and failed looks, with the month taken from this
 * device's clock for the wording only.
 */
export function Boot({ failed }: { readonly failed: boolean }) {
  const s = useStore();
  const month = MONTH_NAMES[new Date().getMonth()] ?? '';
  return <div style={{ position: 'absolute', left: 440, top: 236, width: 560, display: 'flex', flexDirection: 'column' }}>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', gap: 14 }}>
      {Array.from({ length: 42 }, (_, i) => <div key={i} className={cls(!failed && 'wait')} aria-hidden="true" style={{ height: 68, borderRadius: 5, background: failed ? 'transparent' : color.tileLoading, boxShadow: failed ? 'inset 0 0 0 1px rgba(255, 255, 255, 0.07)' : 'none' }} />)}
    </div>
    <div role="status" style={{ marginTop: 16, height: 44, display: 'flex', alignItems: 'center', justifyContent: failed ? 'space-between' : 'center', fontFamily: font.label, fontSize: 12, letterSpacing: '0.04em', color: color.textStatus }}>
      {failed ? <span>{copy.month.failed(month)}</span> : <Spinner label={copy.month.loading(month)} />}
      {failed && <button type="button" className={cls('ctl', 'qb')} onClick={() => { void s.start(); }} style={{ height: 44, padding: '0 12px', border: 'none', borderRadius: 6, background: 'transparent', color: color.textStrong, fontFamily: font.label, fontSize: 12, cursor: 'pointer' }}>{copy.tryAgain}</button>}
    </div>
  </div>;
}
